const STORAGE_KEY = 'postLoginRedirect';

// Only same-app paths are allowed, so a stored value can never send the user to another site.
const isSafePath = (path) =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');

/** Remember where the user was heading, so login can send them back there. */
export function savePostLoginRedirect(path) {
  if (!isSafePath(path)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // sessionStorage unavailable: fall back to the default landing page
  }
}

/** Returns the saved path (once) or null. */
export function takePostLoginRedirect() {
  try {
    const path = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return isSafePath(path) ? path : null;
  } catch {
    return null;
  }
}
